import React from 'react';
import { Link } from 'react-router';

export const FamilyInfo = ({ family, t }) => {
  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="d-inline-flex align-items-center justify-content-center rounded-3 me-3" style={{ width: '64px', height: '64px', background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)' }}>
              <i className="bi bi-people-fill" style={{ fontSize: '30px', color: '#3b82f6' }}></i>
            </div>
            <div>
              <h3 className="h5 fw-bold mb-1">{family.name}</h3>
              <p className="text-muted mb-0">{t('dashboard.index.family_established')} {family.established_year}</p>
            </div>
          </div>
          <Link to="/family/edit" className="btn btn-sm btn-link text-secondary">
            <i className="bi bi-pencil" style={{ fontSize: '18px' }}></i>
          </Link>
        </div>
      </div>
    </div>
  );
};
